import type { PublicJobInfo } from '@crew/shared';
import { formatJobDate, relativeDayLabel } from '@/lib/format';
import { ClockIcon, PinIcon } from '../icons';

/** פרטי העבודה כפי שהקבלן רואה אותם. */
export function PublicJobCard({ job }: { job: PublicJobInfo }) {
  const rel = relativeDayLabel(job.date);
  return (
    <section className="overflow-hidden rounded-control border border-line">
      <div className="bg-brand px-4 py-3 text-white">
        <div className="text-[12px] text-steel">העבודה</div>
        <h2 className="text-[19px] font-extrabold leading-snug">{job.name}</h2>
      </div>
      <dl className="space-y-2.5 px-4 py-3 text-[15px]">
        <div>
          <dt className="sr-only">תאריך</dt>
          <dd className="font-semibold">
            {rel && <span className="text-accent">{rel} · </span>}
            {formatJobDate(job.date)}
          </dd>
        </div>
        <div className="flex items-center gap-2">
          <dt className="text-ink-3">
            <ClockIcon size={17} />
            <span className="sr-only">שעת התייצבות</span>
          </dt>
          <dd>
            התייצבות ב-<strong className="tabular">{job.reportTime}</strong>
          </dd>
        </div>
        <div className="flex items-start gap-2">
          <dt className="mt-0.5 text-ink-3">
            <PinIcon size={17} />
            <span className="sr-only">מיקום</span>
          </dt>
          <dd>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(job.location)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-brand underline underline-offset-2"
            >
              {job.location}
            </a>
          </dd>
        </div>
        {job.notes && <p className="whitespace-pre-line rounded-[8px] bg-paper p-3 text-[14px] text-ink-2">{job.notes}</p>}
      </dl>
    </section>
  );
}
